export const shareUrlService = {
    makeUrl(entrySegment, slug) {
        return `${window.location.protocol}//${window.location.host}/${entrySegment}/${slug}`;
    },
    makeUrlWithLang(entrySegment, slug, lang) {
        return `${this.makeUrl(entrySegment, slug)}?lang=${lang}`;
    },
};
